

































import Vue from "vue"
import PublicIcon from "./PPublicIcon.vue"
import Overlay from "~/components/guideline/modal/Overlay.vue"
import MaterialIcon, {
  FILLED,
} from "~/components/guideline/icon/MaterialIcon.vue"

export default Vue.extend({
  components: {
    Overlay,
    MaterialIcon,
    PublicIcon,
  },
  props: {
    isShownModal: {
      type: Boolean,
      default: true,
    },
    publicStatus: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconType() {
      return { FILLED }
    },
    iconName() {
      switch (this.publicStatus) {
        case "open_to_public":
          return "public"
        case "open_to_users":
          return "groups"
        case "close":
          return "business"
        default:
          return "public"
      }
    },
  },
  watch: {
    // TODO : スクロールロックがうまくできないため、一時的にスクロールした後モーダルが消えるようにしている。
    // スクロールロックを実現したらここを改修。
    isShownModal(isShownModal: boolean) {
      if (isShownModal) {
        window.addEventListener("scroll", this.handleScroll)
      } else {
        window.removeEventListener("scroll", this.handleScroll)
      }
    },
  },
  methods: {
    hideModal() {
      this.$emit("hide-modal")
    },
    handleScroll() {
      this.hideModal()
    },
    handleClickOverlay() {
      this.hideModal()
    },
    handleClickClearIcon() {
      this.hideModal()
    },
    handleClickPublicStatusIcon() {
      this.$emit("click-public-icon")
    },
  },
})
